/**
 * Business / personal / all.
 *
 * Personal finds are hidden by default — they are not stock and they would
 * distort every figure — but they are still tracked, so there has to be a way
 * to fold them in or look at the kept pile on its own.
 */

export const SCOPES = ["business", "personal", "all"] as const;
export type Scope = (typeof SCOPES)[number];

const LABEL: Record<Scope, string> = {
  business: "Business",
  personal: "Personal",
  all: "Everything",
};

const HINT: Record<Scope, string> = {
  business: "Resale stock only — personal finds are hidden.",
  personal: "Only what you kept for yourself.",
  all: "Everything, business and personal together.",
};

export function ScopePicker({
  scope,
  onChange,
  personalCount,
}: {
  scope: Scope;
  onChange: (s: Scope) => void;
  personalCount?: number;
}) {
  return (
    <div className="scope-picker">
      <div className="scope-tabs" role="tablist" aria-label="Which items to show">
        {SCOPES.map((s) => (
          <button
            key={s}
            type="button"
            role="tab"
            aria-selected={scope === s}
            className={`scope-tab ${scope === s ? "active" : ""}`}
            onClick={() => onChange(s)}
          >
            {LABEL[s]}
            {s === "personal" && personalCount !== undefined && personalCount > 0 && (
              <span className="num scope-count">{personalCount}</span>
            )}
          </button>
        ))}
      </div>
      <p className="hint" style={{ margin: "0.35rem 0 0" }}>{HINT[scope]}</p>
    </div>
  );
}
